import { trackDppEvent } from '@/data/dpp/tracker';
import type { DppQuickCartDestination } from '@/data/dpp/types';
import { useCallback, useEffect, useRef } from 'react';

export const useQuickCartEvents = (partNumber?: string) => {
	const viewTracked = useRef(false);

	useEffect(() => {
		if (!partNumber || viewTracked.current) return;
		viewTracked.current = true;
		trackDppEvent({ type: 'quick_cart_view', partNumber, source: 'quick_cart' });
	}, [partNumber]);

	const trackQuickCartClick = useCallback(
		(destination: DppQuickCartDestination) => {
			if (!partNumber) return;
			trackDppEvent({ type: 'quick_cart_click', partNumber, destination, source: 'quick_cart' });
		},
		[partNumber]
	);

	return { trackQuickCartClick };
};
